<template>
  <v-layout row fill-height id="homepage">
    <v-flex xs8 id="home-list-all">
      <v-layout wrap class="pt-4">
        <v-flex xs12>
          <v-form @submit.prevent="searchExaminations">
            <v-layout wrap>

              <v-flex xs3 class="pl-4 pr-2">
                <v-menu
                  v-model="seachFromMenu"
                  :close-on-content-click="false"
                  full-width
                  max-width="290"
                >
                    <v-text-field
                      slot="activator"
                      :value="computedFromDate"
                      label="From"
                      readonly
                    ></v-text-field>
                  <v-date-picker
                    v-model="searchFromDate"
                    @change="seachFromMenu = false"
                    no-title
                    :max="searchToDate"
                  ></v-date-picker>
                </v-menu>
              </v-flex>

              <v-flex xs3 class="px-2">
                <v-menu
                  v-model="seachToMenu"
                  :close-on-content-click="false"
                  full-width
                  max-width="290"
                >
                    <v-text-field
                      slot="activator"
                      :value="computedToDate"
                      label="To"
                      readonly
                    ></v-text-field>
                  <v-date-picker
                    v-model="searchToDate"
                    @change="seachToMenu = false"
                    no-title 
                    :min="searchFromDate"
                  ></v-date-picker>
                </v-menu>
              </v-flex>

              <v-flex xs6 class="pl-2 pr-4">
                <v-text-field
                  v-model="seachMedicalRecords"
                  label="Medical Records"
                  flat
                  hide-details
                  :rules="xssRules"
                ></v-text-field>
              </v-flex>

              <v-flex id="search-btn-container" xs12>
                <v-btn type="submit" round color="primary" dark>Search</v-btn>
                <v-btn type="button" round color="primary" dark @click="fetchTodayExaminationsList()">Today</v-btn>
              </v-flex>

            </v-layout>
          </v-form>
        </v-flex>

        <v-layout row justify-space-between class="pt-4 px-4">
          <h1 class="headline font-weight-light">Examinations</h1>
          <v-btn type="submit" round color="primary" dark @click="fetchNewExaminationsList()">Sync Worklist</v-btn>
        </v-layout>

        <v-flex xs12 fill-height>
          <template>
            <v-data-table
              :headers="headers"
              :items="getExaminations"
              :search="search"
              class="ma-4"
              :rows-per-page-items="rowsPerPages"
            >
              <template slot="items" slot-scope="props">
                <tr :class="{ active: selectedExamination === props.item.url }" @click="goToPage(props.item.url); selectExamination(props.item.url)">
                  <td>{{ props.item.date.replace(/\//g, "-") }}</td>
                  <td>{{ props.item.accNo }}</td>
                  <td>{{ examinationType(props.item.examination_typeID) }}</td>
                  <td>{{ props.item.patientName }}</td>
                  <td>{{ props.item.medicalRecord }}</td>
                  <td v-bind:style="{ 'background-color': statusColor(props.item.examinationStatus)}">{{ examinationStatus(props.item.examinationStatus)}}</td>
                  <td>{{ reportStatus(props.item.reportStatus) }}</td>
                </tr>
              </template>
            </v-data-table>
          </template>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex xs4 id="home-list-detail">
       <router-view/>
    </v-flex>
  </v-layout>
</template>

<script>
  import moment from 'moment'
  import { mapGetters, mapActions } from 'vuex'

  export default {
    data () {
      return {
        search: '',
        rowsPerPages: [10, 20, { text: "$vuetify.dataIterator.rowsPerPageAll", value: -1 }],
        pagination: {
          rowsPerPage: -1
        },
        headers: [
          {
            text: 'Date',
            align: 'left',
            value: 'date'
          },
          {
            text: 'Examination Record',
            align: 'left',
            value: 'accNo'
          },
          { 
            text: 'Examination Type',
            align: 'left', 
            value: 'examination_typeID' 
          },
          { 
            text: 'Patient Name',
            align: 'left', 
            value: 'patientName'
          },
          {
            text: 'Medical Record',
            align: 'left',
            value: 'medicalRecord'
          },
          { 
            text: 'Status',
            align: 'left', 
            value: 'examinationStatus' 
          },
          { 
            text: 'Report Status',
            align: 'left', 
            value: 'reportStatus' 
          }
        ],
        selectedExamination: null,
        examinationList:[],
        seachFromMenu: false,
        searchFromDate: new Date().toISOString().substr(0, 10),
        seachToMenu: false,
        searchToDate: new Date().toISOString().substr(0, 10),
        seachMedicalRecords: '',
        examinationTypesList:['', 'Gastroscopy', 'Colonoscopy', 'Sigmoidoscopy'],
        reportStatusList:['Unedited', 'Editing', 'Finalized'],
        examinationStatusList:['Unfinished', 'Executing', 'Finished'],
        xssRules: [
          value => {
            if ( this.seachMedicalRecords == null){
              return this.seachMedicalRecords = ''
            } else { 
              let xssFilter = new RegExp(/(\b)(on\S+)(\s*)=|javascript|(<\s*)(\/*)script/ig)
              this.seachMedicalRecords = this.seachMedicalRecords.replace(/[&><%^&"]/g, '')
              this.seachMedicalRecords = (xssFilter.test(this.seachMedicalRecords)) ? this.seachMedicalRecords = '' : this.seachMedicalRecords
              return true
            } 
        }],         
      }
    },

    created(){
       window.onkeydown = function(e) {};
       window.onkeyup = function(e) {};

       this.$forceUpdate();
       let condition = {
          from : this.searchFromDate,
          to : this.searchToDate,
          medicalRecord : this.seachMedicalRecords
        }
       this.fetchExaminationsList(condition);
    },
    
    computed: {
      ...mapGetters('examinations', [
        'getExaminations'
      ]),

      computedFromDate () {
        return this.searchFromDate ? moment(this.searchFromDate).format('MM-DD-YYYY') : ''
      },

      computedToDate () {
        return this.searchToDate ? moment(this.searchToDate).format('MM-DD-YYYY') : ''
      }
    },

    methods: {
      ...mapActions('examinations', ['fetchExaminationsList', 'fetchNewExaminationsList']),

      goToPage (page) {
        this.$router.push({ path: `/home/${page}` })
      },

      selectExamination (id) {
        this.selectedExamination = id
      },

      fetchTodayExaminationsList () {
        this.searchFromDate = new Date().toISOString().substr(0, 10);
        this.searchToDate = new Date().toISOString().substr(0, 10);
        this.seachMedicalRecords = '';
        let condition = {
          from : this.searchFromDate,
          to : this.searchToDate,
          medicalRecord : this.seachMedicalRecords
        }
        this.fetchExaminationsList(condition);
        this.$forceUpdate();
      },
      searchExaminations () {
        let condition = {
          from : this.searchFromDate,
          to : this.searchToDate,
          medicalRecord : this.seachMedicalRecords
        }
        this.fetchExaminationsList(condition);
        this.$forceUpdate();
      },
      examinationType(number){  
        return this.examinationTypesList[number];
      },
      examinationStatus(number){  
        return this.examinationStatusList[number];
      },
      reportStatus(number){
        return this.reportStatusList[number];
      },
      statusColor(number){
        let condition = this.examinationStatusList[number];
        return condition === 'Finished' ? '#FFC49BCC' : null ;
      }
    }
  }


</script>

<style lang="scss" scoped>
  #homepage {
    position: absolute;
    width: 100%;
    height: 100%;
    overflow: hidden;

    h1 {
      font-size: 20px !important;
    }

    h4 {
      font-size: 18px !important;
    }
  }

  #home-list-all {
    overflow: auto;
    border-right: 1px solid rgba(0,0,0,0.12);
  }

  #home-list-detail {
    overflow-y: auto;
  }

  .search-container {
    /deep/ .v-text-field.v-text-field--enclosed > .v-input__control > .v-input__slot {
      padding: 0;
    }

    /deep/ .theme--light.v-text-field--solo > .v-input__control > .v-input__slot {
      background: transparent;
    }
  }

  #search-btn-container {
    position: relative;
    text-align: center;

    &:after {
      content: '';
      display: block;
      width: 100%;
      height: 1px;
      background-color: rgba(0,0,0,0.12);
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
    }

    /deep/ > .v-btn {
      z-index: 1;
      padding-left: 28px;
      padding-right: 28px;
    }
  }

  tr.active,
  .theme--light.v-table tbody tr.active:hover:not(.v-datatable__expand-row) {
    background: #d6d6d6;
  }

  .headline {
    padding-top: 10px;
  }
</style>